<template>
    <div v-if="showTable" class="cost-details cost-payment-details">
        <h4 v-translate>Payment Details</h4>
        <table class="table">
            <thead>
                <tr>
                    <td v-translate>Date</td>
                    <td v-translate>Amount</td>
                    <td></td>
                </tr>
            </thead>
            <tbody>
                <tr v-for="a_transaction in transactionList" :key="a_transaction.id">
                    <td>{{ a_transaction.date }}</td>
                    <td>{{ a_transaction.amount }}</td>

                    <td>
                    <GekkoButton 
                        @click="deleteTransaction(a_transaction.id)" 
                        icon="fa-solid fa-trash-can" 
                        class="text-danger"
                        variant="link" 
                    />
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
    import CostService from "@/store/services/cost.service.js";
    import GekkoButton from "@/components/GekkoButton";

    export default {
        name: "CostTransactions",
        props: {
            costId: Number,
        },
        components: { GekkoButton },
        data() {
            return {
                transactionList: [],
            }
        },
        watch: {
            costId: function (newVal, oldVal) {
                if(newVal !== oldVal){
                    this.getTransactions();
                }
            }
        },
        created(){
        },
        methods: {
            getTransactions(){
                let vm = this;
                if(this.costId){
                    CostService.listTransactions(this.costId).then(function (response) {
                        vm.transactionList = response.data;
                    })
                }
            },
            deleteTransaction(transaction_id){
                let vm = this;
                CostService.deleteTransaction(this.costId, {'transaction':transaction_id}).then(function () {
                    for(var i in vm.transactionList){
                        if(vm.transactionList[i].id === transaction_id){
                            vm.transactionList.splice(i, 1);
                            break;
                        }
                    }
                })
            }
        },
        computed:{
            showTable(){
                return this.transactionList.length > 0;
            }
        }
    };
</script>
<style>

</style>
<style scoped>
    .text-class{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: unset;
        display: block;
        max-width: 120px;
    }
</style>